// @flow
export const dataKey: 'purchases_by_payment_mode' = 'purchases_by_payment_mode';
